export const ROUTES = {
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  EDIT_PROFILE: "EDIT_PROFILE",
  FAQ_MANAGEMENT: "FAQ_MANAGEMENT",
};
